import * as React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { generateClientId } from "../../lib/generateClientId";
import { loadCompanyValueFeaturesWorker } from "../actions";
import { categorizedFeaturesSelector } from "../selectors";
import CompanyValuesSelector from "./CompanyValuesSelector";

export type CompanyValue = WtdModels.Partial<
  WtdModels.CompanyValue,
  | "id"
  | "feature"
  | "description"
  | "rank"
  | "feature_cd"
  | "feature_color"
  | "feature_title"
  | "feature_title_with_break"
>;

export interface CompanyValuesSelectorContainerModels {
  CompanyValue: CompanyValue;
}

interface OwnProps {
  companyValues: CompanyValue[];
  onSubmit(companyValues: CompanyValue[]): void;
  onCancel(): void;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface State {
  selectedFeatures: string[];
}

class CompanyValuesSelectorContainer extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedFeatures: props.companyValues
        .filter(v => v.rank >= 0)
        .sort((a, b) => a.rank - b.rank)
        .map(v => v.feature),
    };
  }

  public componentDidMount() {
    const { loadingFeatures, featuresLoaded, loadCompanyValueFeaturesWorker } = this.props;
    if (!featuresLoaded && !loadingFeatures) {
      loadCompanyValueFeaturesWorker();
    }
  }

  public onChange = (selectedFeatures: string[]) => {
    this.setState({ selectedFeatures });
  };

  public onSubmit = () => {
    const { companyValues, companyValueFeatures } = this.props;
    const { selectedFeatures } = this.state;
    let newValues: CompanyValue[] = selectedFeatures.map((feature, i) => {
      const found = companyValues.find(v => v.feature === feature);
      if (found) {
        return { ...found, rank: i + 1 };
      }
      const valueFeature = companyValueFeatures.find(f => f.feature === feature)!;
      return {
        id: generateClientId(), // TODO(KentoMoriwaki): Use temporary client id
        feature,
        description: "",
        rank: i + 1,
        // Properties below will be ignored on save
        feature_cd: valueFeature.feature_cd,
        feature_color: valueFeature.feature_color,
        feature_title: valueFeature.feature_title,
        feature_title_with_break: valueFeature.feature_title_with_break,
      };
    });
    newValues = newValues.concat(
      companyValues.filter(v => !newValues.find(nv => nv.feature === v.feature)).map(v => ({ ...v, rank: -1 }))
    );
    this.props.onSubmit!(newValues);
  };

  public onCancel = () => {
    this.props.onCancel();
  };

  public render() {
    const { features, companyValueFeatures } = this.props;
    const { selectedFeatures } = this.state;
    return (
      <CompanyValuesSelector
        features={features}
        companyValueFeatures={companyValueFeatures}
        selectedFeatures={selectedFeatures}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
      />
    );
  }
}

function mapStateToProps(state: RootState) {
  return {
    companyValueFeatures: state.company_values.features.list,
    loadingFeatures: state.company_values.features.isLoading,
    featuresLoaded: state.company_values.features.isLoaded,
    features: categorizedFeaturesSelector(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>) {
  return bindActionCreators(
    {
      loadCompanyValueFeaturesWorker,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyValuesSelectorContainer);



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesSelectorContainer.tsx